import React, { useState } from "react";
import { IP } from "../internalServer";

const ZoomableImage = ({
  src,
  alt = "Image",
  width = "60px",
  height = "50px",
}) => {
  const [zoomed, setZoomed] = useState(false);
  return (
    <>
      {/* Thumbnail */}
      <img
        src={`${IP}${src}`}
        alt={alt}
        onClick={() => setZoomed(true)}
        style={{
          width,
          height,
          objectFit: "cover",
          borderRadius: "6px",
          marginBottom: "5px",
          cursor: "pointer",
        }}
      />

      {/* Fullscreen Zoom */}
      {zoomed && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          {/* Close button */}
          <button
            onClick={() => setZoomed(false)}
            style={{
              position: "absolute",
              top: "20px",
              right: "30px",
              background: "transparent",
              border: "none",
              fontSize: "2rem",
              color: "white",
              cursor: "pointer",
              zIndex: 10000,
            }}
            aria-label="Close"
          >
            &times;
          </button>

          {/* Zoomed image */}
          <img
            src={`${IP}${src}`}
            alt={alt}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
              boxShadow: "0 0 10px #000",
            }}
          />
        </div>
      )}
    </>
  );
};

export default ZoomableImage;
